import MobileTabsHeader from 'components/TabsHeader/MobileTabsHeader';
import TabsHeader from 'components/TabsHeader/TabsHeader';
import { usePerms } from 'contexts/PermsContext';
import RolesTab from 'features/Admin/Roles/RolesTab';
import { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import MembersTab from './Components/MembersTab';

export default function RoleManager() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const perms = usePerms();
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  const renderTab = () => {
    switch (params.get('tab')?.toLowerCase()) {
      case 'roles':
        if (perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewRoles']))
          return (
            <RolesTab
              mousePosition={mousePosition}
              setMousePosition={setMousePosition}
              perms={perms}
            />
          );
        break;
      case 'users':
        if (perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewUsers']))
          return (
            <MembersTab
              mousePosition={mousePosition}
              perms={perms}
              setMousePosition={setMousePosition}
              hideCreateUserButton
              onCreateUser={() => {
                navigate('/system/createuser?tab=create new user');
              }}
            />
          );
        break;
      default:
        return (
          <RolesTab
            mousePosition={mousePosition}
            setMousePosition={setMousePosition}
            perms={perms}
          />
        );
    }
  };

  return (
    <Container fluid className="py-3 h-100 d-flex flex-column" style={{ boxSizing: 'border-box' }}>
      {/* header */}
      <div className="d-none d-lg-block">
        <TabsHeader
          options={[
            ...(perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewRoles'])
              ? [{ option: 'Roles' }]
              : []),
            ...(perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewUsers'])
              ? [{ option: 'Users' }]
              : []),
          ]}
        />
      </div>
      <div className="d-block d-lg-none">
        <MobileTabsHeader
          options={[
            ...(perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewRoles'])
              ? [{ option: 'Roles' }]
              : []),
            ...(perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewUsers'])
              ? [{ option: 'Users' }]
              : []),
          ]}
        />
      </div>
      {/* content */}
      <div className="d-flex flex-grow-1" style={{ minHeight: 0 }}>
        {renderTab()}
      </div>
    </Container>
  );
}
